module.exports = "<hybse-admin-listusers [userType]=\"'Investor'\">\n\n</hybse-admin-listusers>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/investor/listuser/investor-user-list.component.html
// module id = ../../../../../src/app/components/pages/users/investor/listuser/investor-user-list.component.html
// module chunks = main